import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { FileUploadService, FileUpload } from 'src/app/services/file-upload.service';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: '[app-file-group]',
  templateUrl: './file-group.component.html',
  styleUrls: ['./file-group.component.scss']
})
export class FileGroupComponent implements OnInit, OnChanges, OnDestroy {

  @Input() title?: string;
  @Input() single?: boolean = false;
  @Input() listName: string;
  @Input() listId: number;
  @Input() appropriatorId: number;
  @Input() disabled?: boolean;
  @Input() multiple?: boolean = false;
  @Input() borderless?: boolean = false;
  @Input() index?: number;
  @Input() arrayName?: string;
  @Input() printMode?: boolean = false;
  @Input() showUser?: boolean = false;

  @Output() listEvent = new EventEmitter<ListEvent>();

  fileList: FileUpload[] = [];
  ready: boolean = false;

  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private fileUploadService: FileUploadService
  ) { }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.listId) this.getEvent();
    else this.ready = true;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getEvent() {
    let promise = this.fileUploadService.getFileList(this.listId);
    promise.then((result: Response) => {
      this.fileList = result.body as any;
      this.ready = true;
    });
  }

  postEvent($event) {
    let tempListId = '';
    if (this.listId) tempListId = this.listId.toString();
    let promise = this.fileUploadService.postFiles($event, this.appropriatorId, tempListId);

    promise.then((result: Response) => {
      this.fileList = result.body as any;
      if (this.fileList[0].fileUploadListId !== undefined) {
        let listId = this.fileList[0].fileUploadListId;
        if (this.listId !== listId) {
          const listData = {
            listName: this.listName,
            listId: listId,
            index: null,
            arrayName: null
          };
          if ((typeof this.index) === "number") listData.index = this.index;
          if (this.arrayName) listData.arrayName = this.arrayName;
          this.listEvent.emit(listData);
        }
      }
    });
  }

  downloadEvent($event) {
    let promise = this.fileUploadService.downloadFile($event.fileUploadId);
    promise.then((result) => saveAs(result as Blob, $event.fileName));
  }

  deleteEvent($event) {
    let promise = this.fileUploadService.deleteFile($event);
    promise.then(() => this.getEvent());
  }

}

export interface ListEvent {
  listName: string,
  listId: number,
  index: number,
  arrayName: string
}
